import { render, staticRenderFns } from "./ControleTopico.vue?vue&type=template&id=b4a076fc&scoped=true&"
import script from "./ControleTopico.vue?vue&type=script&lang=js&"
export * from "./ControleTopico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a076fc",
  null
  
)

export default component.exports